import React, {useState} from 'react';
import './Spell.css'
import {FavouriteButton} from "./FavouriteButton";

export const Spell = ({
                          spell,
                          added,
                          addButton,
                          removeButton,
                          adding,
                          isFavourite,
                          toggleFavourite,
                          showBook,
                          showClasses,
                          showSchool
}) => {
    const [show, setShow] = useState(false);

    if (spell.divider) return (
        <div className="spellDivider">
            <div/>
                <span>{spell.level}</span>
            <div/>
        </div>
    );

    const optionalRender = (prefix, value, wrapValue) =>
        value ? (
            <p>{prefix ? <span className="detail">{prefix}</span> : ''}{
                wrapValue ? (<span className="wrappable">{value}</span>) : value
            }</p>
        ) : <></>;

    const renderDetails = () => show ? (
        <div className="spellDetails">
            <div className="topDetails">
                <div className="topDetailsBlock">
                    {optionalRender('Range: ', spell.range)}
                    {optionalRender('Casting time: ', spell.casting_time)}
                </div>
                <div className="topDetailsBlock">
                    {optionalRender('Duration: ', spell.duration)}
                    {optionalRender('Concentration: ', `${spell.concentration ? 'Yes' : 'No'}`)}
                    {optionalRender('Ritual: ', `${spell.ritual ? 'Yes' : 'No'}`)}
                </div>
            </div>
            <div className="spellDesc">
                <p>{spell.description}</p>
                {spell.higher_levels && (<p>{spell.higher_levels}</p>)}
            </div>
            <div className="topDetails">
                <div className="topDetailsBlock">
                    {showClasses && optionalRender('Classes: ', spell.classes && spell.classes.replaceAll(',', ', '), true)}
                    {optionalRender('Components: ', spell.components && spell.components.join(', '))}
                </div>
                <div className="topDetailsBlock">
                    {showSchool && optionalRender('School: ', spell.school)}
                    {showBook && optionalRender('Book: ', spell.book)}
                </div>
            </div>
        </div>
    ) : (<></>)

    const renderSpellShadow = (go) => {
        return adding &&(
            <div className={`spell shadow ${adding.gone ? 'gone' : ''} ${go ? 'go' : 'fadeIn'}`}>
                <div
                    className="spellHeader"
                >
                    {
                        addButton ? (
                            <FavouriteButton
                                active={isFavourite}
                                onClick={() => toggleFavourite(spell)}
                            />
                        ) : ''
                    }
                    <div className="spellHeaderText">
                    <span className="spellName">
                        {spell.name}
                    </span>
                        <span className="spellLvl">
                        lvl{' '}{spell.level}
                    </span>
                    </div>
                    {go ? addButton : removeButton}
                </div>
            </div>
        )
    }

    return (
        <>
            <div className={`spell ${spell.light ? 'light' : ''} ${adding ? 'adding' : ''} ${adding && adding.gone ? 'gone' : ''}`}>
                <div
                    className={`spellHeader`}
                >
                    {
                        addButton ? (
                            <FavouriteButton
                                active={isFavourite}
                                onClick={() => toggleFavourite(spell)}
                            />
                        ) : ''
                    }
                    <div
                        className="spellHeaderText"
                        onClick={() => setShow(s => !s)}
                    >
                    <span className="spellName">
                        {spell.name}
                    </span>
                        <span className="spellLvl">
                        lvl{' '}{spell.level}
                    </span>
                    </div>
                    {spell.light ? undefined : added ? removeButton : addButton}
                </div>
                {renderDetails()}
            </div>
            {renderSpellShadow(true)}
            {renderSpellShadow()}
        </>
    );
}